import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { AuthService, ConfigurationService } from 'mbs-ui-shared@services';
import { first, map } from 'rxjs/operators';

export const supportPortalGuard = () => {
  const authFacade = inject(AuthFacade);
  const authService = inject(AuthService);
  const config = inject(ConfigurationService);
  const router = inject(Router);

  return authFacade.oneTimeAuthTokenRequest$().pipe(
    first(),
    map((res) => {
      if (!res || !config.get('supportUrl')) {
        return router.parseUrl(RoutingPath.ApNotFound);
      }

      const currentPath = window.location.pathname;
      const additionalPath = currentPath.includes(RoutingPath.SupportPortal) ? currentPath.split(RoutingPath.SupportPortal)[1] : '';

      window.location.href = authService.getSupportPortalUrl(res, additionalPath);

      return false;
    })
  );
};
